import THREE from 'three';

export const scene = new THREE.Scene();